<template>
  <i v-if="iconMap[type]" class="dol-icon" :class="'dol-icon-' + type">
    <component :is="'dol-icon-' + type" />
  </i>
</template>

<script>
  import dolphinCoreConfig from '../config';

  export default {
    name: 'dol-icon',
    computed: {
      iconMap(){
        return dolphinCoreConfig.iconMap
      }
    },
    props: {
      type: {type: String},            //数据源，server | local
    },
  }
</script>

<style>
  .dol-icon{
    display: inline-block;
    font-style: normal;
    vertical-align: -0.125em;
    text-align: center;
    text-transform: none;
    line-height: 0;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }
</style>
